/**
 * Today's workout as the live session sees it — A2's `liveOf`, with every
 * input an argument instead of a module-level mock.
 *
 * ── THE CUT IS THE SERVER'S, NOT A LOCAL PERCENTAGE (`D148`) ───────────────
 * The target per exercise is the plan item's `targetSets`, run through the
 * server's readiness `adjustments` (`applyAdjustments`), plus the sets the
 * person added or took off by hand (`extra`). A2 had no server, so it cut
 * locally with `cutSets(ex.sets, cutPct)`; production must not, because the
 * server recorded its own counts when the session started and a local
 * recomputation would disagree with them on the rounding.
 *
 * The readiness PREVIEW (the check-in's "cut" state, shown before
 * `sessionStarted` answers) is the one place a local figure is legitimate:
 * there is no server answer yet, so it previews from the app's own copy of
 * the engine's rule (`workout/store/readiness-preview.ts`), which also fills
 * the `cutPct` and `rirIncrease` the server would have sent. Once the session
 * has started, this function is the only source of the targets.
 *
 * ── A SWAP CHANGES THE EXERCISE, NEVER THE TARGET ──────────────────────────
 * A today-only swap (`Substitution`) is what the remaining sets are recorded
 * under; the number of sets still belongs to the plan item it stands in for —
 * `alternativeAsCard` copies the original's `targetSets` for the same reason.
 * The adjustment is keyed by `itemId`, which a substitute does not have, so
 * the target is computed from the item and the swap only replaces the
 * exercise id.
 */
import { applyAdjustments } from "./readiness";
/**
 * What a plan item stands in as when the plan leaves `targetSets` unspecified
 * — the same default `itemAsCard` draws.
 */
export const DEFAULT_TARGET_SETS = 3;
export function liveWorkout(input) {
    const planned = input.items.map((item) => ({
        ...item,
        targetSets: item.targetSets ?? DEFAULT_TARGET_SETS,
    }));
    const adjusted = applyAdjustments(planned, input.adjustments);
    const exercises = adjusted.map((item, i) => {
        const swap = input.swaps?.[i];
        return { exerciseId: swap?.exerciseId ?? item.exerciseId, item, swap };
    });
    const sets = adjusted.map((item, i) => item.targetSets + (input.extra[i] ?? 0));
    return {
        doneSets: Object.values(input.logged).reduce((n, list) => n + list.length, 0),
        exercises,
        sets,
        totalSets: sets.reduce((a, b) => a + b, 0),
    };
}
//# sourceMappingURL=live-workout.js.map